module.exports = __webpack_public_path__ + "static/media/logo2.ff82723e.svg";